var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPersonMan = function SvgPersonMan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 13a4 4 0 0 0 3.413-6.087c-1.219 1.09-3.933 1.09-5.333 1.09-.984 0-1.654.706-2.063 1.364A4 4 0 0 0 12 13ZM6 9a6 6 0 1 1 10.472 4h1.514c.55 0 1.116.43 1.265.965l1.69 6.07c.149.533-.178.965-.736.966l-16.432.014c-.555 0-.886-.43-.738-.966l1.68-6.082c.147-.534.717-.967 1.263-.967h1.55A5.978 5.978 0 0 1 6 9Zm11.46 6-10.957.002L5.393 19h13.192l-1.126-4Z"
  })));
};

export default SvgPersonMan;